import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#88AC2E",
        secondary: "#27ae60",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        drawerColor: "#88AC2E",
        drawerSecondaryColor: "#88AC2E",
      },
    },
  },
  icons: {
    iconfont: "md",
  },
});
